import React, { useState } from 'react';
import './About.css';
import drimg from '../../img/dravatar.jpg';

const About = () => {
    const [selectedMember, setSelectedMember] = useState(null);

    // Reorder team members: Dr. Kennedy in middle for desktop, first for mobile
    const teamMembers = [
        {
            id: 2,
            name: "Dianne Bain",
            role: "Office Manager",
            image: null,
            description: "Dianne Bain is our experienced Office Manager who ensures smooth daily operations at Atlantic Primary Care. With exceptional organizational skills and a commitment to patient satisfaction, she coordinates appointments, manages administrative tasks, and serves as a friendly point of contact for our patients. Her dedication to excellence helps create a welcoming environment where every patient feels valued and cared for.",
            featured: false
        },
        {
            id: 1,
            name: "Dr. Nahid Kennedy",
            role: "Internal Medicine\nPhysician",
            image: drimg,
            description: "Dr. Nahid Kennedy is a board-certified Internal Medicine physician at Atlantic Primary Care with over 30 years of experience serving Hanover and the South Shore area. She specializes in preventive care and comprehensive chronic disease management, including diabetes, cardiovascular health, gastrointestinal issues, and neurological conditions. Dr. Kennedy is known for her patient-centered approach and commitment to providing personalized, high-quality healthcare to patients throughout the South Shore region.",
            featured: true
        }
        /* 
        // Profile card for new hire - uncomment and update when ready
        {
            id: 3,
            name: "Mikaela Moise",
            role: "Medical Assistant",
            image: null,
            description: "Mikaela Moise is our dedicated Medical Assistant who specializes in patient care coordination and electronic health records management. Her friendly demeanor, attention to detail, and clinical expertise help ensure efficient operations and excellent patient experiences. Mikaela's commitment to patient care and her warm, professional approach contribute to the welcoming atmosphere that makes Atlantic Primary Care a trusted healthcare destination.",
            featured: false
        }
        */
    ];

    const handleCardClick = (memberId) => {
        setSelectedMember(selectedMember === memberId ? null : memberId);
    };

    return (
        <section className="about-section">
            <div className="section-header">
                <span>MEET OUR TEAM</span>
                <h2>Healthcare Professionals at Atlantic Primary Care</h2>
            </div>
            <div className="section-description">
                <p>Atlantic Primary Care is proud to serve Hanover and the South Shore area with experienced healthcare professionals. Our dedicated team is committed to providing quality primary care services. Click on each profile to learn more about our team members and their expertise in serving the South Shore community.</p>
            </div>
            
            {/* Team Cards Layout */}
            <div className="team-cards-container">
                <div className="team-cards">
                    {teamMembers.map((member) => (
                        <div key={member.id} className="team-card-wrapper">
                            <div className={`team-card ${member.featured ? 'featured-card' : 'text-only-card'} ${selectedMember === member.id ? 'active' : ''}`} 
                                 onClick={() => handleCardClick(member.id)}>
                                
                                {/* Card image only for featured member */}
                                {member.image && (
                                    <div className="card-image">
                                        <img src={member.image} alt={`Dr. Nahid Kennedy - Internal Medicine Physician at Atlantic Primary Care`}/>
                                    </div>
                                )}
                                
                                {/* Card content */}
                                <div className="card-content">
                                    <h2>{member.name}</h2>
                                    <p className="role-text">{member.role}</p>
                                    
                                    {/* Profile icon for all cards */}
                                    <div className="profile-icon">
                                        <span>{member.image ? 'View Profile' : 'Learn More'}</span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    ))}
                </div>
                
                {/* Desktop member description - shows below all cards when clicked */}
                {selectedMember && (
                    <div className="desktop-member-description show">
                        {teamMembers.filter(member => member.id === selectedMember).map(member => (
                            <div key={member.id}>
                                <h2>{member.name}</h2>
                                <p>{member.description}</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            
            {/* SEO Content Section */}
            <div className="seo-content">
                <h2>Dr. Nahid Kennedy - Primary Care Physician in Hanover</h2>
                <p>Dr. Nahid Kennedy is a highly experienced Internal Medicine physician serving the South Shore area for over three decades. As the lead physician at Atlantic Primary Care, Dr. Kennedy provides comprehensive primary care services to adult patients in Hanover and surrounding communities.</p>
                
                <h3>Why Choose Dr. Kennedy and Atlantic Primary Care?</h3>
                <ul>
                    <li><strong>Board-Certified Expertise:</strong> Dr. Kennedy is board-certified in Internal Medicine with extensive experience in preventive care and chronic disease management.</li>
                    <li><strong>Convenient Locations:</strong> One office location serving Hanover, MA, making it easy to find doctors near you.</li>
                    <li><strong>Comprehensive Care:</strong> From routine check-ups to complex medical conditions, Dr. Kennedy provides personalized care for all your healthcare needs.</li>
                    <li><strong>South Shore Focus:</strong> Deeply rooted in the South Shore community with over 30 years of serving local families.</li>
                </ul>
                
                {/* Exceptional Primary Care section - commented out but kept in code for future use
                <h3>Exceptional Primary Care That Sets Us Apart</h3>
                <p>Experience healthcare excellence with Dr. Kennedy's personalized approach to medicine. Unlike other practices, we offer same-day appointments, extended office hours, and personalized care that puts your health first. Our comprehensive care model combines medical practices with compassionate, patient-centered care, ensuring you receive the highest quality healthcare in Hanover. From preventive screenings to complex chronic disease management, Dr. Kennedy's expertise and dedication make Atlantic Primary Care the premier choice for adults seeking exceptional primary care services on the South Shore.</p>
                */}
            </div>
        </section>
    );
}

export default About;
